import { useEffect, useState } from "react";

import useLead from "../../hooks/useLead";

import Loader from "../shared/Loader";

import ProfileCard from "../cards/ProfileCard";
import LoanInfoCard from "../cards/LoanInfoCard";
import StatusCard from "../cards/StatusCard";
import AddressCard from "../cards/AddressCard";
import DocumentsCard from "../cards/DocumentsCard";
import ActivityCard from "../cards/ActivityCard";
import ActionFooter from "../cards/ActionFooter";
import LeadEditForm from "./LeadEditForm";
import ConfirmDialog from "../../../../common/confirm/ConfirmDialog";
import Drawer from "../../../../common/drawer/Drawer";
import useFollowups from "../../hooks/useFollowups";
import FollowupCard from "../followup/FollowupCard";
import MediaPickerDialog from "../../../mediaUploader/components/pickers/MediaPickerDialog";
import DocumentPreviewDialog from "../dialogs/DocumentPreviewDialog";

export default function LeadDrawer({

    open,

    leadId,

    onClose

}){
const [

    showDeleteDialog,

    setShowDeleteDialog

]=useState(false);
const [

    activeTab,

    setActiveTab

] = useState("overview");
    const{

        loading,

        lead,

        address,

        documents,

        activities,

        loadLead,setLead,updateLead,deleteCurrentLead,

        updateStatus,

        updateAddress,

        uploadDocument,

        addRemark,refresh

    }=useLead();
    const{

    followups,

    createFollowup,

    completeFollowup,

    deleteFollowup

}=useFollowups(

    leadId

);
  const [

    pickerOpen,

    setPickerOpen

] = useState(false);

const [

    documentType,

    setDocumentType

] = useState(null);
const [

    previewMedia,

    setPreviewMedia

]=useState(null);
const [

    editing,

    setEditing

]=useState(false);
    useEffect(()=>{

        if(open && leadId){
             
            loadLead(leadId);

        }

    },[

        open,

        leadId

    ]);

    if(!open){

        return null;

    }

    return(

        <>

            

                {

                    loading

                    ?

                    <Loader/>

                    :

                    < >
                   <ActionFooter

    onClose={onClose}

    onDelete={()=>{

        

            setShowDeleteDialog(true)

      
        


    }}

/>
                       {

editing

?
<Drawer
        open={!!editing}

    width={650}

    title="Lead Details"

    subtitle={

      ""

    }

    onClose={()=>setEditing(false)}
>

<LeadEditForm

    lead={lead}

    onCancel={()=>

        setEditing(false)

    }

    onSave={async payload=>{

        await updateLead(payload);

        setEditing(false);

    }}

/>
</Drawer>
:

<><div className="lead-tabs">

    <button
        className={
            activeTab==="overview"
            ? "active"
            : ""
        }
        onClick={()=>
            setActiveTab(
                "overview"
            )
        }
    >

        Overview

    </button>

    <button
        className={
            activeTab==="documents"
            ? "active"
            : ""
        }
        onClick={()=>
            setActiveTab(
                "documents"
            )
        }
    >

        Documents

    </button>

    <button
        className={
            activeTab==="activity"
            ? "active"
            : ""
        }
        onClick={()=>
            setActiveTab(
                "activity"
            )
        }
    >

        Activity

    </button>

    <button
        className={
            activeTab==="followups"
            ? "active"
            : ""
        }
        onClick={()=>
            setActiveTab(
                "followups"
            )
        }
    >

        Followups

    </button>

</div>{
activeTab==="overview" &&

<>


    <ProfileCard

        lead={lead}

        onEdit={()=>

            setEditing(true)

        }

    />
 <StatusCard

                            lead={lead}

                            onUpdate={updateStatus}

                        />
                        
    <LoanInfoCard

        lead={lead}

    />
     <AddressCard

                            address={address}

                            onSave={updateAddress}

                        />
                    </>}
                       
</>

}
  


                     
    {

activeTab==="documents" &&                 
<DocumentsCard

    documents={documents}

    onUpload={type=>{

        setDocumentType(type);

        setPickerOpen(true);

    }}

   onPreview={setPreviewMedia}

/>}


                     {

activeTab==="activity" &&   <><ActivityCard

                            activities={activities}

                            onAdd={addRemark}

                        /></>}
                        {

activeTab==="followups" &&<FollowupCard

    followups={followups}

    onCreate={createFollowup}

    onComplete={completeFollowup}

    onDelete={deleteFollowup}

/>}
                      <ActionFooter

    onClose={onClose}

    onDelete={()=>{

     

            setShowDeleteDialog(true)


        


    }}

/>

          </>        

                }
                <ConfirmDialog

    open={showDeleteDialog}

    title="Delete Lead"

    message="This lead will be moved to deleted records. You can restore it later if needed."

    confirmText="Delete Lead"

    loading={loading}

    onCancel={()=>

        setShowDeleteDialog(false)

    }

    onConfirm={async()=>{
        await deleteCurrentLead({reason:"No Reason",deletedBy:1});

        onClose("reload");
    }}

/>

     <DocumentPreviewDialog

    open={!!previewMedia}

    document={previewMedia}

    onClose={()=>

        setPreviewMedia(null)

    }

/>     
<MediaPickerDialog

   
    media={previewMedia}

   
    open={pickerOpen}

    allowUpload

    allowSelect

    onClose={()=>{ setPreviewMedia(null);
        setPickerOpen(false)}


    }

    onSelect={async media=>{

      await uploadDocument({

    doc_type:documentType,

    media_id:media.id,
    lead_id:leadId,
    

    s3_key:media?.file_key

});

setPickerOpen(false);

    }}

/>
<style>{`.lead-tabs{

    display:flex;

    gap:8px;
    flex-wrap:wrap;
    margin-bottom:20px;

    border-bottom:1px solid #E5E7EB;

}

.lead-tabs button{

    border:none;

    background:none;

    padding:12px 18px;

    cursor:pointer;

    color:#64748B;

    font-weight:600;

    border-bottom:2px solid transparent;

}

.lead-tabs button.active{

    color:#2563EB;

    border-color:#2563EB;

}`}</style>
        </>

    );

}